import React from 'react';
import type { ApolloError } from 'apollo-client';
import { FlagRenderer } from '@atlassian/jira-flags';
import { getErrorFlag } from '@atlassian/jira-software-swag';

type Props = {
	error: ApolloError;
};

// @ts-expect-error - TS2322 - Type '{ flag: FlagConfiguration | { type: string; title: MessageDescriptorV2; description: MessageDescriptorV2; error: any; } | { ...; }; }' is not assignable to type 'IntrinsicAttributes'.
export const FlagFromError = ({ error }: Props) => <FlagRenderer flag={getErrorFlag(error)} />;
